import React from "react";

import MainContext from "../MainContext";

import { searchForBus } from "../Requests/ReassignmentRequests";

export default class BusPullForm extends React.Component {

    static contextType = MainContext;

    constructor(){
        super();
        this.state = {
            busRun: "",
            busRoute: "",
            tripOptions: [],
            selectedTrip: {}
        }
    }

    update = (evt) => {
        this.setState({[evt.target.id]: evt.target.value});
    }

    search = () => {

        const params = {
            run: this.state.busRun,
            route: this.state.busRoute,
            location: this.context.user.currentLocation.location_id
        };

        const request = () => searchForBus(params);

        const then = ({data}) => {
            //alert("SEARCH FOR BUS RUN", data);
            this.setState({tripOptions: data});
        }

        this.context.runProcessing(request, then, "addTrip");
    }

    submit = (evt) => {
        console.log("BUS BULL SELECTED TRIP", this.state.selectedTrip);
        this.props.openTripForm(this.state.selectedTrip);
    }

    render(){
        return (
            <div className="trip-switch-form">
                <div style={{
                    height: "92vh",
                    width: "90vw",
                    display: "flex",
                    flexDirection: "column",
                    position: "absolute",
                    top: "4vh",
                    left: "5vw",
                    zIndex: "100",
                    backgroundColor: "white",
                    border: "1px solid black",
                    boxShadow: "1vw 1vh 10vw rgba(0,0,0,0.7)",
                    padding: "1vw"
                }}>
                    <div style={{
                        marginBottom: "2vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <h3>Find the Bus:</h3>
                        <button className="option" onClick={this.props.closeForm}>Close</button>
                    </div>

                    <div style={{
                        display: "grid",
                        alignItems: "flex-end",
                        padding: "2vh 0vw 2vh",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gap: "8px"
                    }}>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "top"
                        }}>
                            <label><h3>Run</h3></label>
                            <input type="text" style={{
                                fontSize: "0.9rem",
                                padding: "6px"
                            }} 
                            id="busRun"
                            value={this.state.busRun}
                            onChange={this.update}
                            />
                        </div>

                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "top"
                        }}>
                            <label><h3>Route</h3></label>
                            <input type="text" style={{
                                fontSize: "0.9rem",
                                padding: "6px"
                            }} 
                            id="busRoute"
                            value={this.state.busRoute}
                            onChange={this.update}
                            />
                        </div>

                        <button className="option" style={{width: "100%"}} onClick={this.search}>Search</button>

                    </div>

                    <div style={{
                        overflowY: "scroll",
                        height: "65%",
                        margin: "1vh 0 2vh"
                    }}>
                        {
                            this.state.tripOptions.map((trip, index) => {
                                return <TripOption 
                                    key={trip.TripNumber + "" + trip.savedIndex + "_" + trip.isUnFilled} 
                                    option={trip}
                                    unFilled={trip.isUnFilled}
                                    selectFunction={() => {
                                        // const pullTrip = {
                                        //     Run: trip.Run,
                                        //     Route: trip.Route,
                                        //     Gate: trip.Gate,
                                        //     SchedDepTime: trip.SchedDepTime
                                        // };
                                        const pullTrip = {...trip};

                                        this.setState({selectedTrip: pullTrip}, () => {
                                            this.submit();
                                        })
                                }} />
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
}



class TripOption extends React.Component {
    render() {

        // console.log("TRIP OPTION", this.props.option);

        let background = "var(--soft-blue-hover)";

        const style = {
            padding: "1vh",
            boxShadow: "0.5vh 0.5vh 1vh rgba(0,0,0,0.4)",
            background,
            display: "grid",
            alignItems: "center",
            justifyContent: "center",
            gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
            margin: "0 0 12px"
        };

        let time = this.props.option.SchedDepTime;
        const timeIndex = time.indexOf(" ");
        time = time.substr(timeIndex);

        return (
            <div style={style}>
                {
                    !this.props.isSelected
                    ? <button className="option" style={{width: "fit-content"}} onClick={this.props.selectFunction}>Select</button>
                    : <span>
                    {
                        this.props.unUsed
                        ? <i className="fas fa-bus"></i>
                        : null
                    }
                    </span>
                }
                <div>
                    Run: <b>{this.props.option.Run}</b>
                </div>
                <div>
                    Route: <b>{this.props.option.Route}</b>
                </div>
                <div>
                    {
                        this.props.option.vehicle_id
                        ? <span>Bus #: <b>{this.props.option.vehicle_id}</b></span>
                        : "_"
                    }
                </div>
                <div>
                    <b>{time}</b>
                </div>
            </div>
        )
    }
}